import { getErrorCode } from '@/shared/api/errorToMessage';
import type { ApiQueryError } from '@/shared/api/errorToMessage';

/** §8.7 «Параллельная правка»: документ успели изменить в другом окне между загрузкой и
 * сохранением. Отличает эту ошибку от прочих, чтобы предложить «Открыть свежую версию» вместо
 * тупикового тоста с сообщением об ошибке. */
export function isVersionConflict(e: unknown): boolean {
  return getErrorCode(e as ApiQueryError) === 'VERSION_CONFLICT';
}
